"use client";

import { c as _c } from "react/compiler-runtime";
import type { CatalogStory } from "@/lib/actions/story-actions";
import { orderByRecommendation } from "@/lib/recommendations/order";
import { StoryGrid } from "./story-grid";
import { TrendingCarousel } from "./trending-carousel";
export function RecommendedResults(t0) {
  const $ = _c(16);
  const {
    stories,
    ids,
    personalized
  } = t0;
  let T0;
  let label;
  let ordered;
  let t1;
  if ($[0] !== ids || $[1] !== personalized || $[2] !== stories) {
    ordered = orderByRecommendation(stories, ids);
    label = personalized ? "For you" : "Recommended";
    T0 = TrendingCarousel;
    t1 = ordered.slice(0, 5);
    $[0] = ids;
    $[1] = personalized;
    $[2] = stories;
    $[3] = T0;
    $[4] = label;
    $[5] = ordered;
    $[6] = t1;
  } else {
    T0 = $[3];
    label = $[4];
    ordered = $[5];
    t1 = $[6];
  }
  let t2;
  if ($[7] !== T0 || $[8] !== t1) {
    t2 = <T0 stories={t1} title="Discover your next read" showNewBadge={false} />;
    $[7] = T0;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== label || $[11] !== ordered) {
    t3 = <StoryGrid stories={ordered} title={label} hideSort={true} />;
    $[10] = label;
    $[11] = ordered;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}